export * from './heading-quill-toolbar-button.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/heading-quill-toolbar-button/index.ts